<template>
  <inline-svg
    @click="clickGitple"
    class="gitple_icon"
    :src="require('@/assets/img/chatbot.svg')"
  />
</template>

<script>
import { watch, computed, onMounted } from "vue";
import { useStore } from "vuex";
import InlineSvg from "vue-inline-svg";
export default {
  name: "GitpleButton",
  components: {
    InlineSvg,
  },
  setup() {
    const store = useStore();
    const serviceName = computed(() => store.getters["common/serviceName"]);
    const userInfo = computed(() => store.state.member.userInfo);
    const gitpleConfig = computed(
      () => store.getters["common/getGitpleConfig"]
    );

    // gitple 스크립트 실행
    const setGitple = () => {
      console.log(serviceName.value);
      window.GitpleConfig = {
        appCode:
          gitpleConfig.value?.appCode ?? "IuS1hGbaHS9CzH7hBvbXIWDBxp19i3",
        id: userInfo.value.phone?.toString() ?? "",
        name: userInfo.value?.memberName ?? "",
        phone: userInfo.value?.phone ?? "",
        meta: {
          service: serviceName.value ?? "",
        },
      };

      !(function () {
        function e() {
          function e() {
            var e = t.contentDocument,
              a = e.createElement("script");
            (a.type = "text/javascript"),
              (a.async = !0),
              (a.src =
                window[n] && window[n].url
                  ? window[n].url + "/inapp-web/gitple-loader.js"
                  : "https://app.gitple.io/inapp-web/gitple-loader.js"),
              (a.charset = "UTF-8"),
              e.head && e.head.appendChild(a);
          }
          var t = document.getElementById(a);
          t ||
            (((t = document.createElement("iframe")).id = a),
            (t.style.display = "none"),
            (t.style.width = "0"),
            (t.style.height = "0"),
            t.addEventListener
              ? t.addEventListener("load", e, !1)
              : t.attachEvent
              ? t.attachEvent("onload", e)
              : (t.onload = e),
            document.body.appendChild(t));
        }
        var t = window,
          n = "GitpleConfig",
          a = "gitple-loader-frame";
        if (!window.Gitple) {
          document;
          var i = function () {
            i.ex && i.ex(arguments);
          };
          (i.q = []),
            (i.ex = function (e) {
              i.processApi ? i.processApi.apply(void 0, e) : i.q && i.q.push(e);
            }),
            (window.Gitple = i),
            t.attachEvent
              ? t.attachEvent("onload", e)
              : t.addEventListener("load", e, !1);
        }
      })();

      window.Gitple("boot");
    };

    watch(
      () => [gitpleConfig.value],
      ([gitpleConfig]) => {
        if (window.GitpleConfig && gitpleConfig?.appCode) {
          window.GitpleConfig.appCode = gitpleConfig.value.appCode;
          window.Gitple("update");
        }
      }
    );

    watch(
      () => [userInfo.value, serviceName.value],
      ([userNewV]) => {
        if (!window.Gitple) {
          return;
        }
        if (Object.keys(userNewV).length) {
          const loginUser = {
            id: userInfo.value.phone?.toString(),
            name: userInfo.value.memberName,
            phone: userInfo.value.phone,
            meta: {
              service: serviceName.value,
            },
          };
          window.GitpleConfig = { ...window.GitpleConfig, ...loginUser };
          window.Gitple("update");
        } else {
          window.GitpleConfig = {
            ...window.GitpleConfig,
            meta: { service: serviceName.value },
          };
          window.Gitple("update");
        }
      }
    );

    const clickGitple = () => {
      if (window.Gitple) {
        window.Gitple("open");
      }
    };

    onMounted(() => {
      setGitple();
    });

    return { clickGitple, serviceName };
  },
};
</script>
